import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const deleteDepartment = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.UpdateDepartment}?CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

export const useDeleteDepartmentMutation = () => {
  return useMutation({
    mutationFn: deleteDepartment,
  });
};
